import { render } from "./Navbar.vue?vue&type=template&id=f9ba9ce0"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=f9ba9ce0&lang=css"
script.render = render

export default script